import BackwardArrow from 'src/assets/icons/BackwardArrow';
import {
  AddAssigneeInactiveSvg,
  AddAssigneeSvg,
  AdditionalAvailabilityInactiveSvg,
  AdditionalAvailabilitySvg,
  ClearTabAddAssigneeSvg,
  ClearTabCalenderSvg,
  ClearTabNewCommentSvg,
  ClearTabPriorityChangedSvg,
  ClearTabRefreshSvg,
  ClearTabStatusChangedSvg,
  NewCommentInactiveSvg,
  NewCommentSvg,
  NewMessageReceivedInactiveSvg,
  NewMessageReceivedSvg,
  PriorityChangedInactiveSvg,
  PriorityChangedSvg,
  StatusChangedInactiveSvg,
  StatusChangedSvg,
  TenantAddAssigneeInactiveSvg,
  TenantAddAssigneeSvg,
  TenantQuotesInactiveSvg,
  TenantQuotesSvg,
  TenantTripsInactiveSvg,
  TenantTripsSvg,
  TickSvg,
} from 'src/assets/icons/BasicNotificationSvg';
import BlockOutCalendarSvg from 'src/assets/icons/BlockOutCalendarSvg';
import BluePencilSvg from 'src/assets/icons/BluePencilSvg';
import {
  AddBlockOutTimeInCalendarSvg,
  AwaitingAvailabilityActionSvg,
  CalendarCenterPlusSvg,
  CalendarSvg,
  CalendarWithTickSvg,
} from 'src/assets/icons/CalendarSvg';
import CancelCloseSvg from 'src/assets/icons/CancelCloseSvg';
import CircleWithWarningExclamation from 'src/assets/icons/CircleWithWarningExclamation';
import CloseIcon from 'src/assets/icons/CloseIcon';
import CircleLoaderFillSvg from 'src/assets/icons/circleLoaderFillSvg';
import CircleLoaderSvg from 'src/assets/icons/circleLoaderSvg';
import { PauseEnRoute, StartEnRoute, StopEnRoute } from 'src/assets/icons/EnrouteSvg';
import ForwardArrowWithBar from 'src/assets/icons/ForwardArrowWithBar';
import ForwardArrowWithOutBar from 'src/assets/icons/ForwardArrowWithOutBar';
import OpenEyeSvg from 'src/assets/icons/OpenEyeSvg';
import PasswordHide from 'src/assets/icons/PasswordHide';
import PasswordShow from 'src/assets/icons/PasswordShow';
import PausedSquareSvg from 'src/assets/icons/PausedSquareSvg';
import PauseTimerSvg from 'src/assets/icons/PauseTimerSvg';
import QualityCheckSvg from 'src/assets/icons/QualityCheckSvg';
import { CreateQuoteSvg, NoTaskCreatedIcon } from 'src/assets/icons/QuoteSvg';
import ReopenSvg from 'src/assets/icons/ReopenSvg';
import ReScheduleArrow from 'src/assets/icons/ReScheduleArrow';
import ResolvedSvg from 'src/assets/icons/ResolvedSvg';
import ResumeTimerSvg from 'src/assets/icons/ResumeTimerSvg';
import SparklesSvg from 'src/assets/icons/Sparkles';
import { ToastSuccessSvg, ToastWarningSvg } from 'src/assets/icons/ToasterSvg';
import { StartWork, WorkOrderPanelTimerSvg } from 'src/assets/icons/WorkOrderPageSvg';
import Wrench from 'src/assets/icons/Wrench';
import ChevronRightSvg from './ChevronRightSvg';
import ClockRewindSvg from './ClockRewindSvg';
import CloseTripSvg from './CloseTripSvg';
import CircleLoaderFillLargeSvg from './circleLoaderFillLargeSvg';
import PauseCircleSvg from './PauseCircleSvg';
import XCircleSvg from './XCircleSvg';

export const PasswordShowIcon = () => <PasswordShow />;
export const PasswordHIdeIcon = () => <PasswordHide />;
export const ReScheduleArrowIcon = () => <ReScheduleArrow />;
export const CalendarSvgIcon = () => <CalendarSvg />;
export const WrenchIcon = () => <Wrench />;
export const SparklesSvgIcon = () => <SparklesSvg />;
export const AddBlockOutTimeInCalendarIcon = () => <AddBlockOutTimeInCalendarSvg />;
export const BlockOutCalendarIcon = () => <BlockOutCalendarSvg />;
export const PendingApproval = () => <ToastWarningSvg />;
export const PendingReview = () => <CircleWithWarningExclamation />;
export const QuoteApproved = () => <ToastSuccessSvg />;
export const QuoteRejected = () => <CancelCloseSvg />;
export const CancelIcon = () => <CancelCloseSvg />;
export const ResolvedIcon = () => <ResolvedSvg />;
export const QuoteCreateArrow = () => <ForwardArrowWithBar />;
export const TripCreateArrow = () => <ForwardArrowWithBar />;
export const QuoteDetailsArrow = () => <ForwardArrowWithOutBar />;
export const CloseSideBar = () => <CloseIcon />;
export const BackwardArrowWithBar = () => <BackwardArrow />;
export const StartEnRouteIcon = () => <StartEnRoute />;
export const StopEnRouteIcon = () => <StopEnRoute />;
export const EndTripIcon = () => <ResolvedSvg />;
export const PauseTimerIcon = () => <PauseTimerSvg />;
export const ResumeTimerIcon = () => <ResumeTimerSvg />;
export const StartTripClockIcon = () => <WorkOrderPanelTimerSvg />;
export const CreateTripIcon = () => <CreateQuoteSvg />;
export const CalendarCenterPlusIcon = () => <CalendarCenterPlusSvg />;
export const CalendarWithTickIcon = () => <CalendarWithTickSvg />;
export const AwaitingAvailabilityActionIcon = () => <AwaitingAvailabilityActionSvg />;
export const PauseIcon = () => <PausedSquareSvg />;
export const PauseCircleIcon = () => <PauseCircleSvg />;
export const BluePencilIcon = () => <BluePencilSvg />;
export const ReopenIcon = () => <ReopenSvg />;
export const QualityCheckIcon = () => <QualityCheckSvg />;
export const NoTaskCreatedSvg = () => <NoTaskCreatedIcon />;
export const OpenEyeIcon = () => <OpenEyeSvg />;
export const ForwardArrowWithOutBarIcon = () => <ForwardArrowWithOutBar />;
export const PriorityChangedIcon = () => <PriorityChangedSvg />;
export const PriorityChangedInactiveIcon = () => <PriorityChangedInactiveSvg />;
export const AddAssigneeIcon = () => <AddAssigneeSvg />;
export const AddAssigneeInactiveIcon = () => <AddAssigneeInactiveSvg />;
export const CoordinatorAddAssigneeIcon = () => <TenantAddAssigneeSvg />;
export const CoordinatorAddAssigneeInactiveIcon = () => <TenantAddAssigneeInactiveSvg />;
export const NewCommentIcon = () => <NewCommentSvg />;
export const NewCommentInactiveIcon = () => <NewCommentInactiveSvg />;
export const StatusChangedIcon = () => <StatusChangedSvg />;
export const StatusChangedInactiveIcon = () => <StatusChangedInactiveSvg />;
export const TickIcon = () => <TickSvg />;
export const ClearTabPriorityChangedIcon = () => <ClearTabPriorityChangedSvg />;
export const ClearTabCalenderIcon = () => <ClearTabCalenderSvg />;
export const ClearTabAddAssigneeIcon = () => <ClearTabAddAssigneeSvg />;
export const ClearTabNewCommentIcon = () => <ClearTabNewCommentSvg />;
export const ClearTabStatusChangedIcon = () => <ClearTabStatusChangedSvg />;
export const ClearTabRefreshIcon = () => <ClearTabRefreshSvg />;
export const CircleLoaderIcon = () => <CircleLoaderSvg />;
export const CircleLoaderFillIcon = () => <CircleLoaderFillSvg />;
export const CircleLoaderFillLargeIcon = () => <CircleLoaderFillLargeSvg />;
export const ClockRewindIcon = () => <ClockRewindSvg />;
export const XCircleIcon = () => <XCircleSvg />;
export const ChevronRightIcon = () => <ChevronRightSvg />;
export const CloseTripSvgIcon = () => <CloseTripSvg />;
export const StartWorkSvg = () => <StartWork />;
export const PauseEnRouteSv = () => <PauseEnRoute />;
export const AdditionalAvailabilityIcon = () => <AdditionalAvailabilitySvg />;
export const AdditionalAvailabilityInactiveIcon = () => <AdditionalAvailabilityInactiveSvg />;
export const CoordinatorTripsSvg = () => <TenantTripsSvg />;
export const CoordinatorTripsInactiveSvg = () => <TenantTripsInactiveSvg />;
export const CoordinatorQuotesSvg = () => <TenantQuotesSvg />;
export const CoordinatorQuotesInactiveSvg = () => <TenantQuotesInactiveSvg />;
export const CoordinatorNewMessageReceivedSvg = () => <NewMessageReceivedSvg />;
export const CoordinatorNewMessageReceivedInactiveSvg = () => <NewMessageReceivedInactiveSvg />;
